export const DESKTOP_LAYOUT_MIN_WIDTH = 1024;

export const isMobileLayout = () =>
  typeof window !== 'undefined' && window.innerWidth < DESKTOP_LAYOUT_MIN_WIDTH;
